

<div class="rt-stepper">
  <form class="stepper">   
    <div class="steps">
      <a class="step">
        <span class="icon">1</span>
        <span class="label">Add</span>
      </a>
      <div class="step-divider"></div>
      <a class="step">
        <span class="icon">2</span>
        <span class="label">Create</span>        
      </a>
      <div class="step-divider"></div>
      <a class="step">
        <span class="icon">3</span>
        <span class="label">Done</span>
      </a>
    </div>
    <div class="rt-stepper-buttons">
      <button class="btn step-back" disabled>Back</button>
      <button class="btn step-next">Next</button>
      <button class="btn step-complete">Complete Step</button>
      <button class="btn step-finish">Finish</button>
    </div>
    
  </form>                    
</div>